import React from "react";
import TestAssignList from "./TestAssignList";
import TestPageShell from "./TestPageShell";

const TestAssign: React.FC = () => (
  <TestPageShell>
    <TestAssignList />
  </TestPageShell>
);

export default TestAssign;
